/**
 * @generated SignedSource<<11a79149f32dd4397a050f67aa4d7d3a>>
 * @relayHash b0ae77e23f0ba505a1a824ef07ccff22
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b0ae77e23f0ba505a1a824ef07ccff22

import { ConcreteRequest } from 'relay-runtime';
export type Ch_sendCareProviderChangeRequestInput = {
  careProviderId: string;
  message: string;
};
export type useChCareProviderSendChangeRequestMutation$variables = {
  input: Ch_sendCareProviderChangeRequestInput;
};
export type useChCareProviderSendChangeRequestMutation$data = {
  readonly ch_sendCareProviderChangeRequest: {
    readonly changeRequest: {
      readonly id: string;
    } | null;
    readonly errors: ReadonlyArray<{
      readonly message?: string;
    }> | null;
  };
};
export type useChCareProviderSendChangeRequestMutation = {
  response: useChCareProviderSendChangeRequestMutation$data;
  variables: useChCareProviderSendChangeRequestMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "concreteType": "ChangeRequest",
  "kind": "LinkedField",
  "name": "changeRequest",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v3 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "message",
      "storageKey": null
    }
  ],
  "type": "Error",
  "abstractKey": "__isError"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useChCareProviderSendChangeRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_sendCareProviderChangeRequestPayload",
        "kind": "LinkedField",
        "name": "ch_sendCareProviderChangeRequest",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useChCareProviderSendChangeRequestMutation",
    "selections": [
      {
        "alias": null,
        "args": (v1/*:: as any*/),
        "concreteType": "Ch_sendCareProviderChangeRequestPayload",
        "kind": "LinkedField",
        "name": "ch_sendCareProviderChangeRequest",
        "plural": false,
        "selections": [
          (v2/*:: as any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": null,
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "__typename",
                "storageKey": null
              },
              (v3/*:: as any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "id": "b0ae77e23f0ba505a1a824ef07ccff22",
    "metadata": {},
    "name": "useChCareProviderSendChangeRequestMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "e31e9562c6cc396ccc7e4de3ee9a3308";

export default node;
